module.exports = __webpack_public_path__ + "static/media/rong.8db568e0.jpg";